
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetosanglicabs() {



    const cardData =
    {
        keyword: ' Pune to Sangli Cab',
        heading: 'Prince Cabs: Pune to Sangli Cab',
        headingDescription: 'Prince Cabs provides dependable Pune to Sangli Cab services, ideal for family travel, business trips, pilgrimages, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride to Sangli, known for its temples, forts, and cultural heritage. With professional chauffeurs, on-time pickups, and flexible schedules, we make your Pune to Sangli travel completely hassle-free. Enjoy affordability, convenience, and trusted service with Prince Cabs’ reliable cab service from Pune to Sangli..',

        top: 'Top Places to Visit in Sangli with Prince Cabs',

"topPlaces": [
  {
    "title": "Sangli Ganapati Temple",
    "description": "The Ganapati Temple in Sangli is the city’s most famous landmark, dedicated to Lord Ganesha. Built in the 19th century by the Patwardhan rulers, it is known for its grand architecture and a large idol carved from black stone. The temple is situated on the banks of the Krishna River, offering a serene and spiritual atmosphere. Thousands of devotees visit during Ganesh Chaturthi and other festivals. The surrounding temple complex is clean and well-maintained. It remains a hub of faith and devotion in Sangli."
  },
  {
    "title": "Sagareshwar Wildlife Sanctuary",
    "description": "Sagareshwar Wildlife Sanctuary is a unique man-made forest spread across 11 square kilometers near Sangli. It houses animals like deer, wild boar, peacocks, and jackals. The sanctuary also has the ancient Sagareshwar Shiva Temple, which attracts both pilgrims and nature lovers. The hilly terrain and scenic views make it a great spot for trekking. During monsoon, the lush greenery enhances its beauty. It is a peaceful retreat combining spirituality and eco-tourism."
  },
  {
    "title": "Dandoba Hill Forest Reserve",
    "description": "Located near Miraj, Dandoba Hill Forest Reserve is a popular trekking and picnic destination. The forest is dotted with ancient temples, caves, and natural trails. Local legends connect it to the epic Ramayana, adding mythological significance. Trekkers enjoy the panoramic views of Sangli district from the hilltop. The area is especially vibrant during monsoon with fresh greenery. It is ideal for families, nature lovers, and adventure seekers."
  },
  {
    "title": "Chintamanrao College Museum",
    "description": "This museum, located inside Chintamanrao College, is one of Sangli’s hidden gems for history and art lovers. It houses ancient artifacts, sculptures, coins, and manuscripts that reflect the region’s cultural heritage. The museum is particularly known for its collection of archaeological finds from nearby areas. Students and researchers visit frequently for academic purposes. It provides an educational and cultural experience for tourists. The museum preserves Sangli’s rich past for future generations."
  },
  {
    "title": "Krishna River Ghats",
    "description": "The Krishna River flows through Sangli, creating scenic ghats used for religious rituals and community gatherings. Pilgrims visit the ghats for holy dips, especially during festivals like Ganesh Chaturthi and Kartik Purnima. The riverbanks are lined with temples and shrines, adding to their spiritual importance. Evenings at the ghats are peaceful, with lamps and prayers creating a divine ambiance. The ghats are also popular for photography and quiet walks. They represent Sangli’s cultural and spiritual life."
  },
  {
    "title": "Miraj Dargah",
    "description": "The Miraj Dargah, dedicated to the Sufi saint Khwaja Samauddin Mira Saheb, is a prominent religious site in Sangli. It attracts devotees from multiple faiths, symbolizing unity and peace. The annual Urs festival is celebrated with great devotion and attracts thousands of visitors. The dargah’s Indo-Islamic architecture adds to its beauty. Spiritual seekers find calm and solace here. It remains an important cultural and religious landmark in the region."
  },
  {
    "title": "Sangli Fort",
    "description": "Sangli Fort, built by the Patwardhan dynasty, reflects the region’s Maratha heritage. It houses administrative offices but also features temples and courtyards within its premises. The fort’s architecture is simple yet sturdy, showcasing Maratha-era designs. Visitors enjoy exploring its historical spaces and learning about Sangli’s royal past. The fort is located near the Ganapati Temple, making it easy to combine both visits. It stands as a reminder of Sangli’s historical and political significance."
  },
  {
    "title": "Irwin Bridge",
    "description": "Irwin Bridge is a historic structure built during the British era across the Krishna River. It is known for its classic colonial design and engineering strength. The bridge connects key parts of Sangli and is still in use today. Tourists admire its architectural beauty, especially during sunset when the river glows below. It has become a popular photography spot. Irwin Bridge is both a functional and historical icon of the city."
  },
  {
    "title": "Kupwad Village (Industrial Hub)",
    "description": "Kupwad, located near Sangli, is known as an important industrial hub with sugar factories, textiles, and small-scale industries. It reflects Sangli’s reputation as the ‘Sugar Belt of India.’ The region also produces turmeric and grapes, contributing to the local economy. Visitors interested in agro-tourism often explore nearby farms and vineyards. Kupwad showcases the blend of tradition and modern industry in Sangli. It is a key contributor to the district’s development."
  },
  {
    "title": "Wineries and Vineyards",
    "description": "Sangli district is one of Maharashtra’s largest wine-producing regions after Nashik. Vineyards and wineries around Miraj and Palus attract wine enthusiasts and tourists. Visitors can tour vineyards, learn about winemaking, and enjoy wine-tasting sessions. The scenic landscapes of grape farms make for a relaxing rural experience. Sangli’s wine industry is steadily gaining national recognition. It is an emerging destination for agro-tourism and luxury experiences."
  }
],


"services": [
    {
        "name": "Pune to Sangli Taxi",
        "description": "Book a safe and comfortable taxi from Pune to Sangli with experienced drivers and well-maintained vehicles. Ideal for both personal and business travel, our service offers door-to-door convenience, punctual pickups, and a smooth highway ride that ensures a relaxing journey every time."
    },
    {
        "name": "Pune to Sangli Car Rental",
        "description": "Hire a private car from Pune to Sangli with flexible rental options, including one-way, round trip, and multi-day bookings. Choose from a wide range of vehicles like sedans, SUVs, and premium cars, all driven by courteous professionals familiar with the route and local stops."
    },
    {
        "name": "Pune to Sangli Cab Booking",
        "description": "Easily book your cab online for a trip from Pune to Sangli with instant confirmation and transparent pricing. Our hassle-free booking process and reliable service make it the perfect choice for commuters, tourists, or anyone visiting Sangli for family or official purposes."
    },
    {
        "name": "Pune to Sangli Cab Service",
        "description": "Our dedicated cab service from Pune to Sangli offers a stress-free travel experience with clean vehicles, timely pickups, and experienced drivers. Whether you're heading to Sangli for a business trip, medical visit, or family event, we ensure your comfort and safety throughout the journey."
    },
    {
        "name": "Pune to Ichalkaranji Cab",
        "description": "Book a cab from Pune to Ichalkaranji, a key textile hub in Maharashtra. We provide fast, comfortable, and economical cab options ideal for professionals, traders, and families. Travel in well-maintained cars with flexible pickup and drop options to suit your schedule."
    },
    {
        "name": "Pune to Sangli Innova Taxi Fare",
        "description": "Get competitive and all-inclusive Innova taxi fares for your Pune to Sangli trip. Our spacious and luxurious Innova cabs are ideal for group travel or long-distance journeys. Enjoy air-conditioned rides, ample luggage space, and a smooth highway drive at a reasonable price."
    },
    {
        "name": "Pune to Satara Cab Service",
        "description": "Travel from Pune to Satara comfortably with our trusted cab service. Perfect for local tourism, family visits, or business meetings, we offer reliable transportation, friendly drivers, and competitive pricing with no hidden charges. Both one-way and round-trip options available."
    },
    {
        "name": "Pune to Satara Cab",
        "description": "Hire a cab from Pune to Satara for a quick and comfortable road journey. Our service features on-time pickups, clean vehicles, and drivers familiar with the Satara region. Ideal for tourists visiting Kaas Plateau, Thoseghar Falls, or other local attractions."
    },
    {
        "name": "Pune to Sangli Dzire Taxi",
        "description": "Choose our Swift Dzire taxi service for an affordable and smooth ride from Pune to Sangli. Ideal for solo travelers or small families, the Dzire offers excellent mileage, AC comfort, and professional drivers ensuring a reliable and pleasant travel experience."
    },
    {
        "name": "Pune to Sangli Round Trip Cab",
        "description": "Plan a round trip from Pune to Sangli with our dependable cab service that offers flexibility and convenience. Our drivers stay with you throughout the journey, allowing multiple stops or waiting time as needed, perfect for attending events or family functions."
    },
    {
        "name": "Pune to Sangli Family Cab",
        "description": "Travel comfortably with your entire family in our dedicated Pune to Sangli family cabs. These spacious vehicles come equipped with safety features, AC, and luggage space. Our trained drivers ensure a smooth journey tailored for family needs and comfort."
    },
    {
        "name": "Pune to Sangli Affordable Taxi",
        "description": "Looking for a budget-friendly ride from Pune to Sangli? Our affordable taxi service offers clean, fuel-efficient vehicles with transparent pricing and no hidden charges. Enjoy a comfortable ride that doesn’t compromise on service quality or safety."
    }
],
"tableData": [
    ["Pune to Sangli Taxi", "Pune to Sangli Car Rental"],
    ["Pune to Sangli Cab Booking", "Pune to Sangli Cab Service"],
    ["Pune to Ichalkaranji Cab", "Pune to Sangli Innova Taxi Fare"],
    ["Pune to Satara Cab Service", "Pune to Satara Cab"],
    ["Pune to Sangli Dzire Taxi", "Pune to Sangli Round Trip Cab"],
    ["Pune to Sangli Family Cab", "Pune to Sangli Affordable Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Sangli Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and professional cab services from Pune to Sangli, catering to travelers visiting for business, family functions, education, or temple visits. With our seamless door-to-door service, we ensure a stress-free travel experience, so you can focus on your purpose of visit while we handle the road."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles for Long Journeys",
        "WhyChoosedescription": "Our cabs are perfectly suited for long-distance travel, featuring clean, spacious, and air-conditioned interiors. With plush seating, smooth suspension, and ample luggage space, your journey to Sangli—spanning around 230 km—becomes not just manageable but enjoyable. You can sit back, relax, and enjoy the scenic Western Maharashtra highway."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Knowledge and Safety Focus",
        "WhyChoosedescription": "Our drivers are skilled, courteous, and familiar with the Pune to Sangli route, including alternate roads to bypass traffic or roadwork. They ensure safe driving, respect your time and comfort, and offer helpful suggestions for rest stops, meals, or short breaks along the way. Your safety and punctuality are always top priorities."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Match Your Schedule",
        "WhyChoosedescription": "We offer highly flexible booking options—choose between one-way drops, round trips, or multi-day hires if you're planning an extended stay. Whether you're leaving early morning or late at night, Prince Cabs will adapt to your timing. Book easily via phone, website, or WhatsApp with instant confirmation and minimal steps."
    },
    {
        "WhyChooseheading": "Clean, Sanitized Vehicles with Safety Protocols in Place",
        "WhyChoosedescription": "All our vehicles are sanitized before and after each trip. We follow strict hygiene protocols and maintain our fleet with regular servicing to ensure there are no breakdowns or issues during your travel. Every cab is equipped with essential safety features such as seat belts, GPS tracking, and first-aid kits."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Secure Payment Modes",
        "WhyChoosedescription": "Prince Cabs believes in 100% transparency. Our Pune to Sangli cab fares are clearly shared before the trip with no hidden charges—what you see is what you pay. You can conveniently pay via UPI, credit/debit card, online banking, or cash, depending on your preference."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Journey",
        "WhyChoosedescription": "Our dedicated customer service team is available round-the-clock to support you before, during, and after your trip. Whether you need to modify your plan, get driver contact details, or manage a delay, we’re just a call or WhatsApp message away to ensure your Pune to Sangli journey is completely smooth and stress-free."
    }
]

















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Pune to Sangli cab services?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services from Pune to Sangli, suitable for personal travel, business visits, or family trips.',
    },
    {
        question: 'What types of cabs are available for Pune to Sangli travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and tempo travellers to accommodate individuals, families, and groups of all sizes.',
    },
    {
        question: 'Is the journey from Pune to Sangli comfortable with Prince Cabs?',
        answer: 'Absolutely! Our vehicles are air-conditioned, well-maintained, and driven by experienced chauffeurs to ensure a smooth and pleasant ride.',
    },
    {
        question: 'Can I customize my Pune to Sangli trip with stops or flexible drop points?',
        answer: 'Yes, you can customize the pickup/drop locations and add stopovers during the journey as per your convenience.',
    },
    {
        question: 'What are the charges for a Pune to Sangli cab?',
        answer: 'Cab fares depend on the vehicle type, travel duration, and specific requirements. Contact Prince Cabs for a competitive and transparent quote.',
    },
    {
        question: 'How do I book a Pune to Sangli cab with Prince Cabs?',
        answer: 'Booking is easy—reach out to us via our website or phone with your travel details, and our team will assist you in selecting the right vehicle.',
    },
    {
        question: 'Are your cabs clean and safe for intercity travel?',
        answer: 'Yes, all our vehicles are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey to Sangli.',
    },
];

const testimonials = [
    {
        name: "Mr. Sandeep Jadhav",
        position: "Business Traveler",
        text: "I frequently travel from Pune to Sangli and always choose Prince Cabs. They’re punctual, professional, and their cabs are always clean.",
        image: "/img/testimonial/testimonial-thumb-sangli-1.png",
    },
    {
        name: "Mrs. Neeta Khot",
        position: "Family Traveler",
        text: "We had a very pleasant Pune to Sangli ride with Prince Cabs. The driver was polite and the car was in excellent condition.",
        image: "/img/testimonial/testimonial-thumb-sangli-2.png",
    },
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sangli Cab",
  "image": "https://princecab.com/assets/images/pune-sangli-cab.jpg",
  "description": "Book Pune to Sangli cab service with Prince Cabs. Reliable and affordable taxi options including Innova, Dzire, and Etios. Ideal for round trips, family travel, and quick bookings. Available 24/7 online.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "6400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-sangli-cab"
  }
};



    return (
        <div>
<Helmet>
  <title>Pune to Sangli Cab | Affordable & Reliable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Sangli taxi services with Innova, Dzire, and Etios cabs. Affordable fares for family travel, round trips, and quick bookings. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Sangli Taxi, Pune to Sangli Car Rental, Pune to Sangli Cab Booking, Pune to Sangli Cab Service, Pune to Ichalkaranji Cab, Pune to Sangli Innova Taxi Fare, Pune to Satara Cab Service, Pune to Satara Cab, Pune to Sangli Dzire Taxi, Pune to Sangli Round Trip Cab, Pune to Sangli Family Cab, Pune to Sangli Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosanglicabs;